import { put, takeLatest, call } from "redux-saga/effects";
import { setChangeLogExcelTableDataFailure, setChangeLogExcelTableDataSuccess } from "../reducers/changeLogExcelDataSlice";
import { fetchDrmExcelData } from "../../service/fetchDrmExcelData";
import { parseChangeLogTableData } from "./drmDataMapper";

export function* workerGetChangeLogExcelDataFetch({ payload }) {
  try {
    const response = yield call(fetchDrmExcelData, [
      payload.reqBody,
      payload.totalPages,
      payload.tableName,
    ]);

    const data = response;
    const parsedData = parseChangeLogTableData(data);

    yield put(
      setChangeLogExcelTableDataSuccess({
        onPage: data?.details?.onPage,
        pageSize: data?.details?.pageSize,
        totalPages: data?.details?.totalPages,
        totalRecords: data?.details?.totalRecords,
        drmMaintenanceDetails: parsedData,
      })
    );
  } catch (error) {
    yield put(setChangeLogExcelTableDataFailure(error.toString()));
  }
}

function* drmChangeLogExcelDataSaga() {
  yield takeLatest(
    "changeLogExcelData/getChangeLogExcelTableData",
    workerGetChangeLogExcelDataFetch
  );
}

export default drmChangeLogExcelDataSaga;
